/* global jQuery, elementorFrontend, ScrollMagic */
( function( $ ) {
	$( window ).on( 'elementor/frontend/init', () => {
		/*--------------------------------------------------------------------------------
		Longitude Numbered List
		--------------------------------------------------------------------------------*/

		/**
		* @param $element The widget wrapper element as a jQuery element
		* @param $ The jQuery alias
		*/
		const longitudeNumberedListHandler = ( $element, $ ) => {
			let element_id = $element.data('id');

			window['controller' + element_id] = new ScrollMagic.Controller({
				globalSceneOptions: {
					duration: 0,
					triggerHook: .7
				}
			});

			new ScrollMagic.Scene({triggerElement: $element[0]})
			.setClassToggle($element[0], "active")
			.reverse(false)
			// .addIndicators()
			.addTo(window['controller' + element_id]);
		};

		elementorFrontend.hooks.addAction( 'frontend/element_ready/longitude-numberedlist.default', longitudeNumberedListHandler );
	} );
} )( jQuery );
